import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2" }
const _hoisted_2 = { class: "col-span-full md:col-span-1 grid grid-cols-2 grid-rows-6 gap-x4 xl:gap-x8 md:mr-30 xl:mr-70" }
const _hoisted_3 = { class: "row-start-2 col-span-1 row-span-5" }
const _hoisted_4 = {
  key: 0,
  "aria-hidden": "true",
  class: "mt-x1 font-cormorant text-12 md:text-13 xl:text-16"
}
const _hoisted_5 = { class: "row-span-5 col-span-1" }
const _hoisted_6 = {
  key: 0,
  "aria-hidden": "true",
  class: "mt-x1 font-cormorant text-12 md:text-13 xl:text-16"
}
const _hoisted_7 = { class: "col-span-full md:col-span-1 md:ml-30 xl:ml-70 flex flex-col justify-center" }
const _hoisted_8 = {
  key: 0,
  class: "mb-x2 mt-x6 md:mt-0 o-text-h2"
}
const _hoisted_9 = { class: "leading-24px" }
const _hoisted_10 = {
  key: 1,
  class: "mt-x4"
}
const _hoisted_11 = { class: "mr-x2" }
const _hoisted_12 = {
  key: 0,
  class: "mt-x8 flex flex-wrap-reverse items-center"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "md:ml-30 xl:ml-70 mb-x4 md:mb-0 flex-1" }
const _hoisted_15 = {
  key: 0,
  "aria-hidden": "true",
  class: "mt-x1 font-cormorant text-12 md:text-13 xl:text-16"
}

import { ProductSeriesTileModel } from '@/types/B2CcontentServerContract';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import colors from '@/styling/0-Settings/colors.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSeriesTile',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "o-tile-wrapper px-x3 sm:px-x5 lg:px-x8 py-x6 md:py-80",
    style: _normalizeStyle({ backgroundColor: __props.content.hexCode || _unref(colors)['wild-sand'] })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("figure", _hoisted_3, [
          _createVNode(MediaHandler, {
            "media-block": __props.content.mediaModel1.media,
            "image-alt-text-override": __props.content.mediaModel1.text,
            "media-aspect-ratio": {'default': 0.79/1},
            "image-width-on-screen": { xs: 50, sm: 40, lg: 25 }
          }, null, 8, ["media-block", "image-alt-text-override", "media-aspect-ratio"]),
          (__props.content.mediaModel1.text)
            ? (_openBlock(), _createElementBlock("figcaption", _hoisted_4, _toDisplayString(__props.content.mediaModel1.text), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("figure", _hoisted_5, [
          _createVNode(MediaHandler, {
            "media-block": __props.content.mediaModel2.media,
            "image-alt-text-override": __props.content.mediaModel2.text,
            "media-aspect-ratio": {'default': 0.79/1},
            "image-width-on-screen": { xs: 50, sm: 40, lg: 25 }
          }, null, 8, ["media-block", "image-alt-text-override", "media-aspect-ratio"]),
          (__props.content.mediaModel2.text)
            ? (_openBlock(), _createElementBlock("figcaption", _hoisted_6, _toDisplayString(__props.content.mediaModel2.text), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (__props.content.heading)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(__props.content.heading), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_9, _toDisplayString(__props.content.seriesDescription), 1),
        (__props.content.uniqueSellingPoints.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.uniqueSellingPoints, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: "flex mt-x2"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_c_icon, {
                      name: "icon-checkmark",
                      class: "w-20 h-16"
                    })
                  ]),
                  _createElementVNode("div", null, _toDisplayString(item), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.content.mediaModel3 && __props.content.bottomDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "md:mr-30 xl:mr-70 md:flex-1 flex flex-col justify-center o-rte-paragraph-line-height",
            innerHTML: __props.content.bottomDescription
          }, null, 8, _hoisted_13),
          _createElementVNode("figure", _hoisted_14, [
            _createVNode(MediaHandler, {
              "media-block": __props.content.mediaModel3.media,
              "image-alt-text-override": __props.content.mediaModel3.text,
              "media-aspect-ratio": {'default': 1.65/1},
              "image-width-on-screen": { xs: 90, lg: 40 }
            }, null, 8, ["media-block", "image-alt-text-override", "media-aspect-ratio"]),
            (__props.content.mediaModel3.text)
              ? (_openBlock(), _createElementBlock("figcaption", _hoisted_15, _toDisplayString(__props.content.mediaModel3.text), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})